// extracted by mini-css-extract-plugin
export default {"password":"RMQConnectionResetPassword_password__7xTjM","button":"RMQConnectionResetPassword_button__5r4Wg"};